/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerTerminationResponseBody } from '../../models/customer-termination-response-body';

export interface TerminateDkvCustomer$Params {

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;

/**
 * UUID to identify the customer
 */
  customerId: string;

/**
 * dkvs number to identify the customer
 */
  dkvCustomerNumber: string;
}

export function terminateDkvCustomer(http: HttpClient, rootUrl: string, params: TerminateDkvCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerTerminationResponseBody>> {
  const rb = new RequestBuilder(rootUrl, terminateDkvCustomer.PATH, 'delete');
  if (params) {
    rb.path('svgId', params.svgId, {});
    rb.path('customerId', params.customerId, {});
    rb.path('dkvCustomerNumber', params.dkvCustomerNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerTerminationResponseBody>;
    })
  );
}

terminateDkvCustomer.PATH = '/svgs/{svgId}/customers/{customerId}/dkv-customer/{dkvCustomerNumber}';
